var _path, _path2, _path3, _line;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnpin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1315 21.0813L18.1315 34.3947L18.1315 21.0813Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1315 21.0813L18.1315 34.3947",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3741 9.06059C22.467 9.06061 22.5589 9.04233 22.6447 9.0068C22.7305 8.97126 22.8085 8.91918 22.8742 8.85352C22.9398 8.78785 22.9919 8.7099 23.0274 8.6241C23.063 8.5383 23.0812 8.44635 23.0812 8.35349L23.0812 7.23201C23.0812 6.96685 22.9758 6.71256 22.7883 6.52506C22.6008 6.33756 22.3465 6.2322 22.0814 6.23216L14.1816 6.23216C13.9164 6.2322 13.6621 6.33756 13.4746 6.52506C13.2871 6.71256 13.1818 6.96685 13.1817 7.23201L13.1817 8.35348C13.1817 8.44635 13.2 8.5383 13.2355 8.6241C13.2711 8.7099 13.3231 8.78785 13.3888 8.85352C13.4545 8.91918 13.5324 8.97126 13.6182 9.00679C13.704 9.04232 13.796 9.06061 13.8888 9.06059C13.9817 9.06058 14.0737 9.07886 14.1595 9.11439C14.2453 9.14992 14.3232 9.202 14.3889 9.26767C14.4545 9.33333 14.5066 9.41129 14.5422 9.49708C14.5777 9.58288 14.596 9.67484 14.5959 9.7677L14.5959 15.7173C14.596 15.9825 14.4907 16.2368 14.3032 16.4244L12.0603 18.6673C11.8728 18.8549 11.7675 19.1093 11.7675 19.3745L11.7675 20.0816C11.7676 20.3467 11.8729 20.601 12.0604 20.7885C12.2479 20.976 12.5022 21.0814 12.7674 21.0814L23.4956 21.0814C23.7608 21.0814 24.0151 20.976 24.2026 20.7885C24.39 20.601 24.4954 20.3467 24.4954 20.0816V19.3744C24.4955 19.1093 24.3902 18.8549 24.2027 18.6673L21.9605 16.4251C21.773 16.2375 21.6677 15.9832 21.6677 15.718L21.6677 9.76841C21.6676 9.67554 21.6858 9.58357 21.7213 9.49774C21.7567 9.4119 21.8087 9.3339 21.8743 9.26817C21.9399 9.20244 22.0178 9.15027 22.1036 9.11466C22.1893 9.07904 22.2813 9.06067 22.3741 9.06059Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10.086,
    y1: 5.20257,
    x2: 27.2516,
    y2: 23.3779,
    stroke: "white",
    strokeWidth: 1.25
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpin);
export default __webpack_public_path__ + "static/media/unpin.d00fd46b.svg";
export { ForwardRef as ReactComponent };